import React, { FC } from 'react'

import { IconHealthyLivingProps } from './IconHealthyLiving.types'
import * as Styled from './styles/IconHealthyLiving.style'

import { nonThemeableRules } from '../../ruleSet'

const IconHealthyLiving: FC<IconHealthyLivingProps> = ({
  size = nonThemeableRules.defaultSize as number as IconHealthyLivingProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconHealthyLivingProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M159.94 46.31C159.86 20.76 140.06 0 115.73 0a43.54 43.54 0 0 0-34.65 17.7A45.07 45.07 0 0 0 45.35 0a46.62 46.62 0 0 0-33.92 14.73 41.1 41.1 0 0 0-11.36 31c1.53 23 15.09 49.17 40.3 77.66a319.57 319.57 0 0 0 37.16 35.74 4 4 0 0 0 5 0c79.02-62.87 77.69-108.87 77.41-112.82zM80 150.85C67.46 140.36 11.05 90.77 8 45.21a33.19 33.19 0 0 1 9.22-25A38.59 38.59 0 0 1 45.35 8a37.05 37.05 0 0 1 30.22 15.71q1 1.46 1.92 3a4 4 0 0 0 .28.5 37.42 37.42 0 0 1 3.06 7.21 4 4 0 0 0 7.65-2.34 45.56 45.56 0 0 0-2.78-7C95.4 9.71 109.82 8 115.73 8c20 0 36.21 17.26 36.21 38.47v.37c.06.43 3.11 43.35-71.94 104.01z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconHealthyLiving
